import React from 'react';
import { Create } from 'react-admin';
import FinanciadorEstudiosForm from '../FinanciadorEstudiosForm';

function FinanciadorEstudiosCreate(props) {
  return (
    <Create {...props}>
      <FinanciadorEstudiosForm redirect="list" />
    </Create>
  );
}

export default FinanciadorEstudiosCreate;
